import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/distribuicao-equipamentos',
  name: 'distribuicao-equipamentos',
  component: Index,
  children: [
    { path: 'listar-aguardando-envio', name: 'distribuicao-equipamentos-aguardando-envio', component: Listar, props: { titulo: 'Listar Aguardando Envio', status: 1 } },
    { path: 'listar-saiu-para-entrega', name: 'distribuicao-equipamentos-listar-saiu-para-entrega', component: Listar, props: { titulo: 'Listar Saiu p/ entrega', status: 2 } },
    { path: 'listar-entrega-confirmada', name: 'distribuicao-equipamentos-entrega-confirmada', component: Listar, props: { titulo: 'Listar Entrega Confirmada', status: 3 } },
    { path: 'novo', name: 'distribuicao-equipamentos-novo', component: Novo, props: true },
    { path: ':id', name: 'distribuicao-equipamentos-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'distribuicao-equipamentos-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/distribuicao-equipamentos/routes.js